export default __webpack_public_path__ + "static/media/person-logo-female.11d4a985.svg";